"use strict";

exports.__esModule = true;
exports.default = void 0;
var _emotion = require("emotion");
var _theme = _interopRequireDefault(require("../theme"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var font = function font(props) {
  return /*#__PURE__*/(
    (0, _emotion.css)("font-family:", props.theme.fontFamily ? props.theme.fontFamily : _theme.default.fontFamily, ";")
  );
};
var _default = font;
exports.default = _default;